import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el) {
		this.el = el;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			controlsText: ['Previous slide', 'Next slide'],
			nav: true,
			navPosition: 'bottom'
		});

		this.makeControlsKeyboardAccessible();
		this.moveNavigationOutsideSlider();

		return mediaContentSlider;
	}

	makeControlsKeyboardAccessible() {
		const outer = this.el.closest('.tns-outer');
		if (!outer) return;

		const controls = outer.querySelector('.tns-controls');
		if (!controls) return;

		controls.removeAttribute('tabindex');
		controls.querySelectorAll('button').forEach((button) => {
			button.setAttribute('tabindex', '0');
		});
	}

	moveNavigationOutsideSlider() {
		const outer = this.el.closest('.tns-outer');
		const wrapper = outer?.closest('.block-media-content__slider-wrapper');
		const nav = outer?.querySelector('.tns-nav');

		if (!wrapper || !nav) return;

		nav.classList.add('block-media-content__slider-nav');
		wrapper.insertAdjacentElement('afterend', nav);
	}
}

export default MediaContentSlider;	